import React from 'react';

// Internal note: lives on the datasheet record but is never rendered into the
// printable pages, so it cannot reach the PDF, the print view or a customer.
export default function InternalNote({ sheet, setSheet }) {
  const value = sheet.internalNote || '';
  return (
    <div className="form-section internal-note-section" data-testid="section-internal-note">
      <div className="internal-note-head">
        Internal note
        <span className="internal-note-chip">Website only</span>
      </div>
      <div className="section-body">
        <textarea
          className="input internal-note-input"
          data-testid="internal-note-input"
          rows={3}
          placeholder="Who the supplier is and where to find our costing — e.g. “Supplier: YuanHui (contact Amy). Costing in NetSuite item ABC-123, 2026 price file on SharePoint.”"
          value={value}
          onChange={e => setSheet(s => ({ ...s, internalNote: e.target.value }))}
        />
        <p className="field-hint" data-testid="internal-note-hint">
          Visible in the app only — it never appears on the datasheet, the exported PDF, the print view or anything a customer sees. Searchable from the library and product search.
        </p>
      </div>
    </div>
  );
}
